var _mask, _path, _mask2, _path2, _path3, _circle, _circle2, _circle3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_195_254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5092 22.2856H27.8867C28.7151 22.2856 29.3867 22.9572 29.3867 23.7856V28.1326C29.3867 28.961 28.7151 29.6326 27.8867 29.6326H23.5092V22.2856Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5092 22.2856H27.8867C28.7151 22.2856 29.3867 22.9572 29.3867 23.7856V28.1326C29.3867 28.961 28.7151 29.6326 27.8867 29.6326H23.5092V22.2856Z",
    stroke: "#00D27E",
    strokeWidth: 4.6,
    mask: "url(#path-1-inside-1_195_254)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_195_254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.87756 29.6328H1.5C0.671576 29.6328 4.76837e-06 28.9612 4.76837e-06 28.1328L4.76837e-06 23.7859C4.76837e-06 22.9574 0.671578 22.2859 1.5 22.2859H5.87756L5.87756 29.6328Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87756 29.6328H1.5C0.671576 29.6328 4.76837e-06 28.9612 4.76837e-06 28.1328L4.76837e-06 23.7859C4.76837e-06 22.9574 0.671578 22.2859 1.5 22.2859H5.87756L5.87756 29.6328Z",
    stroke: "#00D27E",
    strokeWidth: 4.6,
    mask: "url(#path-2-inside-2_195_254)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9938 18.1895H8.25912C6.50082 18.1895 5.07544 19.3955 5.07544 20.8833V31.6589C5.07544 33.1466 6.50082 34.3527 8.25912 34.3527H20.9938C22.7521 34.3527 24.1775 33.1466 24.1775 31.6589V20.8833C24.1775 19.3955 22.7521 18.1895 20.9938 18.1895Z",
    stroke: "#00D27E",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.93887,
    cy: 13.4694,
    r: 1.46939,
    fill: "#00D27E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2873,
    cy: 23.755,
    r: 1.46939,
    fill: "#00D27E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1032,
    cy: 23.755,
    r: 1.46939,
    fill: "#00D27E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93774 22.2859L2.93774 14.939",
    stroke: "#00D27E",
    strokeWidth: 2.3,
    strokeLinecap: "square"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_254)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5966 9.46161C28.6458 9.51077 28.6606 9.58474 28.634 9.64902C28.6074 9.7133 28.5447 9.75521 28.4751 9.75521C28.4055 9.75521 28.3428 9.7133 28.3162 9.64902C28.2896 9.58474 28.3044 9.51077 28.3536 9.46161V9.46161C28.4207 9.39456 28.5295 9.39456 28.5966 9.46161",
    fill: "#00D27E",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5966 9.46161C28.6458 9.51077 28.6606 9.58474 28.634 9.64902C28.6074 9.7133 28.5447 9.75521 28.4751 9.75521C28.4055 9.75521 28.3428 9.7133 28.3162 9.64902C28.2896 9.58474 28.3044 9.51077 28.3536 9.46161V9.46161C28.4207 9.39456 28.5295 9.39456 28.5966 9.46161",
    stroke: "#00D27E",
    strokeOpacity: 0.5,
    strokeWidth: 0.458333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6214 9.46161C30.6706 9.51077 30.6854 9.58474 30.6588 9.64902C30.6322 9.7133 30.5695 9.75521 30.4999 9.75521C30.4303 9.75521 30.3676 9.7133 30.341 9.64902C30.3144 9.58474 30.3292 9.51077 30.3784 9.46161V9.46161C30.4455 9.39456 30.5543 9.39456 30.6214 9.46161",
    stroke: "#00D27E",
    strokeOpacity: 0.5,
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6234 7.82322V11.3296C34.6236 11.7158 34.4702 12.0862 34.1972 12.3594C33.9242 12.6326 33.5538 12.7862 33.1676 12.7863H30.9557L28.6631 14.6204V12.7863H27.8263C27.022 12.7863 26.37 12.1343 26.37 11.33V11.33V7.82322C26.37 7.01894 27.022 6.36694 27.8263 6.36694H33.1672C33.9714 6.36694 34.6234 7.01894 34.6234 7.82322V7.82322Z",
    stroke: "#00D27E",
    strokeOpacity: 0.5,
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7925 10.9585H31.8755",
    stroke: "#00D27E",
    strokeOpacity: 0.5,
    strokeWidth: 1.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(25 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.abd85303aec35cb730c82c8cce47894c.svg";
export { ForwardRef as ReactComponent };